import React, { useState, ReactElement } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { bindActionCreators, compose } from 'redux';
import MuiDrawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import InboxIcon from '@material-ui/icons/AssignmentOutlined';
import CodeIcon from '@material-ui/icons/CodeOutlined';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ClientsIcon from '@material-ui/icons/PeopleOutline';
import ClientTypeIcon from '@material-ui/icons/ContactsOutlined';
import AccountIcon from '@material-ui/icons/AccountBoxOutlined';
import SetIcon from '@material-ui/icons/DnsOutlined';
import RegionsIcon from '@material-ui/icons/PlaceOutlined';
import CurrencyIcon from '@material-ui/icons/AttachMoneyOutlined';
import SecurityIcon from '@material-ui/icons/SecurityOutlined';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import SupportIcon from '@material-ui/icons/ContactSupportOutlined';
import SvgIcon from '@material-ui/core/SvgIcon';
import Tooltip from '@material-ui/core/Tooltip';
import Fade from '@material-ui/core/Fade';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import drawerActions from '../../actions/DrawerActions';

const drawerWidth = 256;
const hoverTextColor = '#64c8f6';
const styles = (theme: any): any =>
  createStyles({
    drawerOpen: {
      top: '64px',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      background: '#263238',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      top: '64px',
      whiteSpace: 'nowrap',
      background: '#263238',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: 60,
      [theme.breakpoints.up('sm')]: {
        width: 60,
      },
    },
    nested: {
      paddingLeft: 38,
    },
    listText: {
      color: 'white',
      fontSize: '16px',
      '&:hover': {
        color: hoverTextColor,
      },
    },
    hoverListText: {
      color: hoverTextColor,
      fontSize: '16px',
    },
    nestedListText: {
      color: '#FFFFFFB3',
      fontSize: '16px',
    },
    hoverNestedListText: {
      color: hoverTextColor,
      fontSize: '16px',
    },
    tooltip: {
      fontSize: 14,
      marginLeft: '2px',
    },
    svgIcon: {
      pointerEvents: 'none',
    },
    nestedItems: {
      opacity: 0.7,
    },
  });

const useStyles = makeStyles<typeof styles>(styles);

interface Props {
  open?: boolean;
  closeDrawer?: () => void;
  openDrawer?: () => void;
  history: any;
  setCurrentItem?: any;
  currentItem?: any;
  profile?: any;
}

const Drawer = (props: Props): ReactElement => {
  const {
    open,
    closeDrawer,
    openDrawer,
    history,
    setCurrentItem,
    currentItem,
    profile,
  } = props;

  const classes = useStyles();

  const [expandedItems, setExpandedItems] = useState<any>([]);
  const [hoverListItem, setHoverListItem] = useState<any>(null);

  const setExpandedItem = (title: any): void => {
    if (expandedItems.indexOf(title) > -1) {
      const newExpandedItems = expandedItems.filter(
        (each: any): any => each !== title
      );
      setExpandedItems(newExpandedItems);
    } else {
      const newExpandedItems = expandedItems.concat(title);
      setExpandedItems(newExpandedItems);
    }
  };

  const role =
    profile && profile.roles && profile.roles[0] && profile.roles[0].name;
  const drawerItems = [
    {
      title: 'Home',
      Icon: HomeIcon,
      route: '/',
      id: 100,
    },
    {
      title: 'Basic Data',
      Icon: InboxIcon,
      id: 200,
      nested: [
        {
          title: 'Clients',
          Icon: ClientsIcon,
          route: '/clients',
          id: 201,
          sub: true,
        },
        {
          title: 'Client Groups',
          Icon: ClientTypeIcon,
          route: '/client-group',
          id: 202,
          sub: true,
        },
        {
          title: 'Asset Class Sets',
          Icon: SetIcon,
          route: '/asset-class-set',
          id: 203,
          sub: true,
        },
        {
          title: 'Asset Managers',
          // eslint-disable-next-line react/display-name
          Icon: (propsData: any): any => (
            <SvgIcon {...propsData} className={classes.svgIcon}>
              <path d="M5.816493768413386,6.993903343448061 v-1.8902441468778544 c0,-0.31189028423484655 0.24538333085494057,-0.5670732440633566 0.5452962907887553,-0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,0.25518295982851036 0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 -0.24538333085494057,0.5670732440633566 -0.5452962907887553,0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,-0.25518295982851036 -0.5452962907887553,-0.5670732440633566 zm6.361790059202141,0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm-5.816493768413386,4.53658595250685 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm5.816493768413386,0 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm-3.453543174995448,3.969512708443494 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 zm3.453543174995448,0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm8.179444361831324,5.859756855321348 v1.7012197321900688 H0 v-1.7012197321900688 c0,-0.31189028423484655 0.24538333085494057,-0.5670732440633566 0.5452962907887553,-0.5670732440633566 h0.886106472531727 V1.1341464881267127 c0,-0.628506178836887 0.48622252595330656,-1.1341464881267127 1.0905925815775104,-1.1341464881267127 h15.313737499650864 c0.6043700556242037,0 1.0905925815775104,0.5056403092898263 1.0905925815775104,1.1341464881267127 v20.792685615656396 H19.812431898658094 c0.2999129599338156,0 0.5452962907887553,0.25518295982851036 0.5452962907887553,0.5670732440633566 zM3.6125879264755016,21.879576000111165 H8.724740652620081 v-3.1661589460204063 c0,-0.31189028423484655 0.24538333085494057,-0.5670732440633566 0.5452962907887553,-0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,0.25518295982851036 0.5452962907887553,0.5670732440633566 v3.1661589460204063 h5.112152726144577 V2.3155490799253715 L3.6353086052583654,2.268292976253425 l-0.02272067878286485,19.611283023857737 z" />
            </SvgIcon>
          ),
          route: '/asset-manager',
          id: 204,
          sub: true,
        },
        {
          title: 'Account Codes',
          Icon: CodeIcon,
          route: '/account-code',
          id: 205,
          sub: true,
        },
        {
          title: 'Account Types',
          Icon: AccountIcon,
          route: '/account-type',
          id: 206,
          sub: true,
        },
        {
          title: 'Regions',
          Icon: RegionsIcon,
          route: '/region',
          id: 207,
          sub: true,
        },
        {
          title: 'Currencies',
          Icon: CurrencyIcon,
          route: '/currencies',
          id: 208,
          sub: true,
        },
        {
          title: 'Securities',
          Icon: SecurityIcon,
          route: '/security',
          id: 209,
          sub: true,
        },
        {
          title: 'Benchmarks',
          // eslint-disable-next-line react/display-name
          Icon: (propsData: any): any => (
            <SvgIcon {...propsData} className={classes.svgIcon}>
              <path d="M20.288624699596987,18.50949242823248 H2.6178870580125144 V0.9254746214116236 c0,-0.5113247283299225 -0.2928761146151505,-0.9254746214116236 -0.6544717645031294,-0.9254746214116236 H0.6544717645031294 C0.2928761146151505,0 0,0.41414989308170325 0,0.9254746214116236 v19.434967049644104 c0,1.0220710350214623 0.5861612740831147,1.8509492428232477 1.3089435290062577,1.8509492428232477 h18.97968117059073 c0.3615956498879787,0 0.6544717645031294,-0.41414989308170214 0.6544717645031294,-0.9254746214116236 v-1.8509492428232477 c0,-0.5113247283299225 -0.2928761146151505,-0.9254746214116236 -0.6544717645031294,-0.9254746214116236 zM18.97968117059073,1.8509492428232477 H14.150497638263268 c-0.8745378953173054,0 -1.3126249326815873,1.495219935218156 -0.6941491152261312,2.36979345245214 l1.3253053231188354,1.8740861083585387 L11.780491761056314,10.339286786082987 l-3.0011620850996588,-4.243879560810678 c-0.5113060660180694,-0.7230270479778309 -1.3400309378201554,-0.7230270479778309 -1.8509279589854106,0 l-2.8097290939824937,3.9731782340477784 c-0.25565303300903475,0.36151352398891584 -0.25565303300903475,0.9474546436701501 0,1.3089681676590659 l0.9252594570662984,1.3083897460206844 c0.25565303300903475,0.36151352398891584 0.6700154689100778,0.36151352398891584 0.9256685019191123,0 L7.853661174037543,10.021154884972741 l3.0011620850996588,4.243879560810678 c0.5113060660180694,0.7230270479778309 1.3400309378201554,0.7230270479778309 1.8509279589854106,0 l3.9268305870187716,-5.552847728469744 l1.3253053231188354,1.8740861083585387 c0.6184758174554568,0.8745735172339847 1.6758567619808238,0.25508394252657907 1.6758567619808238,-0.9815815203347036 V2.776423864234872 c0.00040904485281445605,-0.5113247283299225 -0.292467069762336,-0.9254746214116236 -0.6540627196503145,-0.9254746214116236 z" />
            </SvgIcon>
          ),
          id: 210,
          route: '/benchmark',
          sub: true,
        },
      ],
    },
    {
      title: 'Overview',
      // eslint-disable-next-line react/display-name
      Icon: (propsData: any): any => (
        <SvgIcon {...propsData} className={classes.svgIcon}>
          <path d="m12.931168,0.132137l-0.086997,0.638936l-9.406372,0l0,1.25227l9.183558,0l-0.371357,2.087116l2.28033,0l-0.371357,-2.087116l9.183558,0l0,-1.25227l-9.406372,0l-0.113734,-0.638936l-0.877888,0zm-12.49626,4.117462l0.723898,6.103005l-0.631653,2.662882l0.781533,0l1.61159,-2.264312l5.997266,1.203918l0.104475,0.293309c0.356305,1.00112 0.895911,1.760552 1.433042,2.263686c0.537131,0.502995 1.08971,0.729656 1.337281,0.729656l6.337825,0c1.138828,0 2.279636,-0.276752 3.087016,-0.780929c0.40364,-0.252054 0.720234,-0.558999 0.922451,-0.883754c0.086353,-0.138654 0.151811,-0.277795 0.199741,-0.422432l-7.671937,0l-2.376684,-7.7919l-0.349868,0l-3.168913,3.339386l-5.969588,0l-1.584456,-4.452514l-0.783018,0zm12.825431,1.113129l1.994731,6.53963l2.199324,0l-1.994731,-6.53963l-2.199324,0zm3.178815,0.032698l1.984829,6.506932l3.918459,0c-0.384874,-2.402827 -1.235876,-3.957311 -2.333458,-4.973597c-1.023658,-0.947898 -2.280973,-1.41423 -3.569829,-1.533335zm2.303651,11.074655c-0.203405,0.015514 -0.407997,0.023932 -0.61264,0.023932l-0.321249,0l0.495143,2.087116l-4.308929,0l0.495143,-2.087116l-0.939583,0l-0.495143,2.087116l-4.08552,0l0,1.25227l12.475959,0l1.189332,-1.235851l0.358285,-0.372202l-0.529951,-1.006964l-0.358335,0.372202l-0.953149,0.990545l-1.908527,0l-0.500837,-2.111048z" />
        </SvgIcon>
      ),
      id: 300,
      nested: [
        {
          title: 'Clients',
          Icon: ClientsIcon,
          route: '/clients-overview',
          id: 301,
          sub: true,
        },
        {
          title: 'Asset Managers',
          // eslint-disable-next-line react/display-name
          Icon: (propsData: any): any => (
            <SvgIcon {...propsData} className={classes.svgIcon}>
              <path d="M5.816493768413386,6.993903343448061 v-1.8902441468778544 c0,-0.31189028423484655 0.24538333085494057,-0.5670732440633566 0.5452962907887553,-0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,0.25518295982851036 0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 -0.24538333085494057,0.5670732440633566 -0.5452962907887553,0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,-0.25518295982851036 -0.5452962907887553,-0.5670732440633566 zm6.361790059202141,0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm-5.816493768413386,4.53658595250685 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm5.816493768413386,0 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm-3.453543174995448,3.969512708443494 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 zm3.453543174995448,0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,-0.25518295982851036 0.5452962907887553,-0.5670732440633566 v-1.8902441468778544 c0,-0.31189028423484655 -0.24538333085494057,-0.5670732440633566 -0.5452962907887553,-0.5670732440633566 h-1.8176543026291836 c-0.2999129599338156,0 -0.5452962907887553,0.25518295982851036 -0.5452962907887553,0.5670732440633566 v1.8902441468778544 c0,0.31189028423484655 0.24538333085494057,0.5670732440633566 0.5452962907887553,0.5670732440633566 zm8.179444361831324,5.859756855321348 v1.7012197321900688 H0 v-1.7012197321900688 c0,-0.31189028423484655 0.24538333085494057,-0.5670732440633566 0.5452962907887553,-0.5670732440633566 h0.886106472531727 V1.1341464881267127 c0,-0.628506178836887 0.48622252595330656,-1.1341464881267127 1.0905925815775104,-1.1341464881267127 h15.313737499650864 c0.6043700556242037,0 1.0905925815775104,0.5056403092898263 1.0905925815775104,1.1341464881267127 v20.792685615656396 H19.812431898658094 c0.2999129599338156,0 0.5452962907887553,0.25518295982851036 0.5452962907887553,0.5670732440633566 zM3.6125879264755016,21.879576000111165 H8.724740652620081 v-3.1661589460204063 c0,-0.31189028423484655 0.24538333085494057,-0.5670732440633566 0.5452962907887553,-0.5670732440633566 h1.8176543026291836 c0.2999129599338156,0 0.5452962907887553,0.25518295982851036 0.5452962907887553,0.5670732440633566 v3.1661589460204063 h5.112152726144577 V2.3155490799253715 L3.6353086052583654,2.268292976253425 l-0.02272067878286485,19.611283023857737 z" />
            </SvgIcon>
          ),
          route: '/assetmanagers-overview',
          id: 302,
          sub: true,
        },
        {
          title: 'Securities',
          Icon: SecurityIcon,
          route: '/securities-overview',
          id: 303,
          sub: true,
        },
      ],
    },

    {
      title: 'Support',
      Icon: SupportIcon,
      externalLink: true,
      route: 'https://iassetmonitor.zendesk.com',
      link: 'https://iassetmonitor.zendesk.com',
      id: 500,
    },
  ];

  if (!(role === 'ADMIN' || role === 'SUPER_ADMIN'))
    return <span style={{ display: 'none' }} />;
  return (
    <MuiDrawer
      classes={{
        paper: classNames({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
        root: classNames({
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
      open={open}
      variant="permanent"
      onClose={(): void => {
        if (closeDrawer) closeDrawer();
      }}
    >
      <List
        style={{ marginLeft: 3 }}
        onMouseOut={(): void => {
          setHoverListItem(null);
        }}
        onBlur={(): void => {
          // for on muse out
        }}
        component="nav"
      >
        {drawerItems.map(
          (item: any): ReactElement => (
            <div key={item.title ? item.title : item}>
              {!(!open && item.id === hoverListItem) && (
                <>
                  <ListItem
                    key={item.title}
                    classes={{ root: classes.listText }}
                    onMouseOver={(): void => {
                      setHoverListItem(item.id);
                    }}
                    onFocus={(): void => {
                      // for on mouse hover
                    }}
                    button
                    onClick={(): void => {
                      if (!item.route) {
                        setExpandedItem(item.title);
                      }
                      if (item.nested && openDrawer) openDrawer();
                      if (item.title === 'Home') {
                        history.push(item.route);
                        setCurrentItem(item.id);
                        if (closeDrawer) closeDrawer();
                      }
                      if (item.title === 'Reports') {
                        history.push(item.route);
                        setCurrentItem(item.id);
                        if (closeDrawer) closeDrawer();
                      }
                      if (item?.externalLink) {
                        window.open(item.link, '_blank');
                      }
                    }}
                    className={classNames({
                      [classes.nestedItems]: item.sub,
                    })}
                  >
                    <ListItemIcon classes={{ root: classes.listText }}>
                      <item.Icon
                        style={{
                          width: 20,
                          color: item.id === hoverListItem && hoverTextColor,
                        }}
                      />
                    </ListItemIcon>

                    <ListItemText
                      classes={{
                        primary:
                          item.id === hoverListItem || item.id === currentItem
                            ? classes.hoverListText
                            : classes.listText,
                      }}
                      primary={item.title}
                    />
                    {item.nested &&
                      (expandedItems.indexOf(item.title) > -1 ? (
                        <ExpandLess />
                      ) : (
                        <ExpandMore />
                      ))}
                  </ListItem>
                </>
              )}
              {!open && item.id === hoverListItem && (
                <>
                  <Tooltip
                    title={item.title}
                    placement="right"
                    classes={{
                      tooltip: classes.tooltip,
                    }}
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                  >
                    <ListItem
                      key={item.title}
                      classes={{ root: classes.listText }}
                      onMouseOver={(): void => {
                        setHoverListItem(item.id);
                      }}
                      onFocus={(): void => {
                        // for on mouse hover
                      }}
                      button
                      onClick={(): void => {
                        if (!item.route) {
                          setExpandedItem(item.title);
                        }
                        if (item.nested && openDrawer) openDrawer();
                        if (item.title === 'Home') {
                          history.push(item.route);
                          setCurrentItem(item.id);
                          if (closeDrawer) closeDrawer();
                        }
                        if (item.title === 'Reports') {
                          history.push(item.route);
                          setCurrentItem(item.id);
                          if (closeDrawer) closeDrawer();
                        }
                        if (item?.externalLink) {
                          window.open(item.link, '_blank');
                        }
                      }}
                      className={classNames({
                        [classes.nestedItems]: item.sub,
                      })}
                    >
                      <ListItemIcon classes={{ root: classes.listText }}>
                        <item.Icon
                          style={{
                            width: 20,
                            color: item.id === hoverListItem && hoverTextColor,
                          }}
                        />
                      </ListItemIcon>

                      <ListItemText
                        classes={{
                          primary:
                            item.id === hoverListItem || item.id === currentItem
                              ? classes.hoverListText
                              : classes.listText,
                        }}
                        primary={item.title}
                      />
                      {item.nested &&
                        (expandedItems.indexOf(item.title) > -1 ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        ))}
                    </ListItem>
                  </Tooltip>
                </>
              )}

              <Collapse
                key={item}
                in={expandedItems.indexOf(item.title) > -1}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {item.nested &&
                    item.nested.map(
                      (nest: any): ReactElement => (
                        <div key={nest.title}>
                          {!(!open && nest.id === hoverListItem) && (
                            <ListItem
                              onClick={(): void => {
                                if (history) history.push(nest.route);
                                setCurrentItem(nest.id);
                                if (closeDrawer) closeDrawer();
                              }}
                              onMouseOver={(): void => {
                                setHoverListItem(nest.id);
                              }}
                              onFocus={(): void => {
                                // for on mouse hover
                              }}
                              button
                              className={classNames({
                                [classes.nested]: open,
                                [classes.nestedItems]: nest.sub,
                              })}
                            >
                              <ListItemIcon
                                classes={{
                                  root: classes.nestedListText,
                                }}
                              >
                                <nest.Icon
                                  onClick={(): void => {
                                    history.push(nest.route);
                                    setCurrentItem(nest.id);
                                    if (closeDrawer) closeDrawer();
                                  }}
                                  style={{
                                    width: 20,
                                    color:
                                      (nest.id === hoverListItem ||
                                        nest.id === currentItem) &&
                                      hoverTextColor,
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={nest.title}
                                classes={{
                                  primary:
                                    nest.id === hoverListItem ||
                                    nest.id === currentItem
                                      ? classes.hoverNestedListText
                                      : classes.listText,
                                }}
                              />
                            </ListItem>
                          )}
                          {!open && nest.id === hoverListItem && (
                            <Tooltip
                              title={nest.title}
                              placement="right"
                              classes={{
                                tooltip: classes.tooltip,
                              }}
                              TransitionComponent={Fade}
                              TransitionProps={{ timeout: 600 }}
                            >
                              <ListItem
                                onClick={(): void => {
                                  history.push(nest.route);
                                  setCurrentItem(nest.id);
                                  if (closeDrawer) closeDrawer();
                                }}
                                onMouseOver={(): void => {
                                  setHoverListItem(nest.id);
                                }}
                                onFocus={(): void => {
                                  // for on mouse hover
                                }}
                                button
                                className={classNames({
                                  [classes.nested]: open,
                                })}
                              >
                                <ListItemIcon
                                  style={{ zIndex: 20 }}
                                  classes={{
                                    root: classes.nestedListText,
                                  }}
                                >
                                  <nest.Icon
                                    onClick={(): void => {
                                      history.push(nest.route);
                                      setCurrentItem(nest.id);
                                      if (closeDrawer) closeDrawer();
                                    }}
                                    style={{
                                      width: 20,
                                      color:
                                        (nest.id === hoverListItem ||
                                          nest.id === currentItem) &&
                                        hoverTextColor,
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  inset
                                  primary={nest.title}
                                  classes={{
                                    primary:
                                      nest.id === hoverListItem ||
                                      nest.id === currentItem
                                        ? classes.hoverNestedListText
                                        : classes.listText,
                                  }}
                                />
                              </ListItem>
                            </Tooltip>
                          )}
                        </div>
                      )
                    )}
                </List>
              </Collapse>
            </div>
          )
        )}
      </List>
    </MuiDrawer>
  );
};

const mapStateToProps = (state: any): any => {
  return {
    open: state.Drawer.open,
    currentItem: state.Drawer.item,
    profile: state.User.profile,
  };
};

const mapDispatchToProps = (dispatch: any): any =>
  bindActionCreators(drawerActions, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(Drawer);
